import { Injectable } from '@angular/core';
import { AppHttpClient } from '../api.interceptor';
import { environment } from '@env/environment';
import { HelpersService } from '@base/shared/services/helpers.service';

@Injectable()
export class QuestionnaireRequests {
  private config = environment;

  constructor(
    private http: AppHttpClient,
    private helpers: HelpersService
  ) {
  }

  /**
   * Get a list of question types
   */
  listQuestionTypes() {
    const url = `${this.config.baseUrl}/v2/${this.config.services.questionnaires}/question_types`;
    return this.http.get(url);
  }

  /**
   * Merge questionnare questions
   * @param type walkthrough, safety, general
   * @param sectionId section definition id or walkthrough Contract SectionId
   * @param contractDefinitionId contrac definition id
   * @param payload data to be sent
   */
  mergeSettingsQuestionsAnswers(type, sectionId, contractDefinitionId, payload) {

    const queryOptions: any = {
      contractDefinitionId: contractDefinitionId
    };

    if (type === 'walkthrough')
      queryOptions.walkthroughContractSectionId = sectionId;
    else
      queryOptions.definitionVersionSectionId = sectionId;

    const query = this.helpers.queryOptions(queryOptions);
    const url = `${this.config.baseUrl}/v2/${this.config.services.questionnaires}/${type}${query}`;

    return this.http.put(url, payload);
  }

  /**
   * List questions from project
   * @param type walkthrough, safety, general
   * @param sectionId section definition id or walkthrough Contract SectionId
   * @param contractDefinitionId contrac definition id
   */
  listSettingsQuestionsAnswers(type, sectionId, contractDefinitionId) {
    const queryOptions: any = {
      contractDefinitionId: contractDefinitionId
    };

    if (type === 'walkthrough')
      queryOptions.walkthroughContractSectionId = sectionId;
    else
      queryOptions.definitionVersionSectionId = sectionId;

    const query = this.helpers.queryOptions(queryOptions);
    const url = `${this.config.baseUrl}/v2/${this.config.services.questionnaires}/${type}${query}`;

    return this.http.get(url);
  }
}
